import { render, staticRenderFns } from "./Text_Default.vue?vue&type=template&id=0a3b4b25&"
import script from "./Text_Default.vue?vue&type=script&lang=js&"
export * from "./Text_Default.vue?vue&type=script&lang=js&"
import style0 from "./Text_Default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports